module.exports = __webpack_public_path__ + "img/logo-shadow.2052941f.png";